module.exports = __webpack_public_path__ + "img/bg-movies-blur.4ac1270.jpg";